import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ClockIcon, FlameIcon } from 'lucide-react';
export function UrgencyBar() {
  const initialTotal = 10 * 60; // 10 minutes
  const [totalSecondsLeft, setTotalSecondsLeft] = useState(initialTotal);
  const minutes = Math.floor(totalSecondsLeft / 60);
  const seconds = totalSecondsLeft % 60;
  const progressPercent = totalSecondsLeft / initialTotal * 100;
  useEffect(() => {
    const timer = setInterval(() => {
      setTotalSecondsLeft(prev => prev <= 0 ? 0 : prev - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const pad = (n: number) => n.toString().padStart(2, '0');
  const scrollToOffer = () => {
    document.getElementById('oferta')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="fixed top-0 left-0 right-0 z-50" data-id="element-485">
      <div className="bg-ancestral-green border-b border-ancestral-gold/30 shadow-lg" data-id="element-486">
        <div className="container mx-auto px-3 md:px-4 py-2 flex items-center justify-between gap-3" data-id="element-487">
          {/* Left: message */}
          <div className="flex items-center gap-2 text-ancestral-cream min-w-0" data-id="element-488">
            <FlameIcon className="w-4 h-4 md:w-5 md:h-5 text-orange-400 flex-shrink-0 animate-pulse" data-id="element-489" />
            <span className="text-xs md:text-sm font-bold uppercase tracking-wide truncate" data-id="element-490">
              <span className="hidden sm:inline" data-id="element-491">
                🔥 Oferta Especial — Termina en:
              </span>
              <span className="sm:hidden" data-id="element-492">Oferta Especial</span>
            </span>
          </div>

          {/* Center: countdown */}
          <div className="flex items-center gap-1.5 flex-shrink-0" data-id="element-493">
            <ClockIcon className="w-4 h-4 text-ancestral-gold hidden md:block" data-id="element-494" />
            <div className="flex items-center gap-1 font-mono" data-id="element-495">
              <span className="bg-black/30 text-ancestral-gold font-bold text-base md:text-lg px-1.5 md:px-2 py-0.5 rounded" data-id="element-496">
                {pad(minutes)}
              </span>
              <span className="text-ancestral-gold font-bold" data-id="element-497">:</span>
              <span className="bg-black/30 text-ancestral-gold font-bold text-base md:text-lg px-1.5 md:px-2 py-0.5 rounded" data-id="element-498">
                {pad(seconds)}
              </span>
            </div>
          </div>

          {/* Right: CTA */}
          <button onClick={scrollToOffer} className="bg-ancestral-gold text-ancestral-green font-bold text-xs md:text-sm px-3 md:px-5 py-1.5 md:py-2 rounded-lg hover:bg-ancestral-gold/90 transition-colors flex-shrink-0 uppercase tracking-wide" data-id="element-499">
            <span className="hidden md:inline" data-id="element-500">¡Ver Oferta!</span>
            <span className="md:hidden" data-id="element-501">Ver Oferta</span>
          </button>
        </div>

        {/* Progress bar */}
        <div className="w-full h-1 bg-black/20" data-id="element-502">
          <motion.div className="h-full bg-gradient-to-r from-ancestral-gold via-yellow-400 to-orange-400" animate={{
          width: `${progressPercent}%`
        }} transition={{
          duration: 0.5,
          ease: 'linear'
        }} data-id="element-503" />
        </div>
      </div>
    </div>;
}